import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box, Dialog, Typography, IconButton, DialogActions, Button, DialogContent } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslate, useDataProvider } from 'react-admin';
import Table from '../common/table';
import PageListLabel from '../page-list-label';
import { lightBlue, grey } from '@material-ui/core/colors';
import TextButton from '../CustomizedUIs/TextButton';
import CloseButton from '../CustomizedUIs/CloseButton';

const useStyles = makeStyles((theme) => ({
    dialogCloseBtn: {
        marginLeft: 7,
        width: "28px",
        height: "28px",
        borderRadius: "10px",
        border: "solid 2px #e5f1f8",
        backgroundColor: " #ffffff",
        padding: 0
    },
    btnClose: {
        fontFamily: " UniviaPro-Bold",
        fontSize: "10px",
        fontWeight: "bold",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: "normal",
        letterSpacing: "0.4px",
        color: "#4f5064",
    },
    dialogTitle: {
        fontFamily: "UniviaPro-Medium",
        fontSize: "18px",
        fontWeight: 500,
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.2,
        letterSpacing: "normal",
        color: "#4f5064",
        marginTop: -10
    },
    dialogActions: {
        paddingLeft: 32,
        paddingRight: 35,
        bottom: 0,
        right: 0,
        backgroundColor: '#f3f7fa'
    },

    disabled: {
        cursor: 'pointer',
        borderBottomColor: grey['900'],
        pointerEvents: 'none',
        opacity: 0.4
    },
    enabled: {
        cursor: 'pointer',
        borderBottomColor: lightBlue['100']
    },
}))

const config = {
    headers: [
        { field: 'firmwareName', label: 'pos.devices.firmware', width: 4, bold: true },
        { field: 'modelName', label: 'pos.devices.model', width: 4 },
        { field: 'version', label: 'pos.devices.version', width: 4 },
    ]
}

export default function DialogListFirmWare({ open, onClose, listDevices, getListDevices }) {
    const translate = useTranslate();
    const classes = useStyles();
    const dataProvider = useDataProvider()
    // STATES
    const [search, setSearchText] = useState('');
    const [loading, setLoading] = useState(false);
    const [listRooms, setListRooms] = useState([]);
    const [firmware, setFirmware] = useState({
        bodies: [],
        sortable: { field: 'name', order: 'DESC' },
    });

    // END STATES
    const getListFirmWare = (onEnter) => {
        if (onEnter)
            return
        const id = listDevices[0]
        if (id) {
            let idProfile = id.profileId
            let idDetailProfile = id.profile && id.profile.id
            dataProvider('GET_ONE', 'firmwarebyprofile', {
                id: id.profileId ? idProfile : idDetailProfile
            }).then(({ data }) => {
                setListRooms(data)
                setLoading(true);
                const firmwares = data.map(item => ({
                    ...item,
                    checked: false
                }));
                setTimeout(() => {
                    setLoading(false);
                    setFirmware({
                        ...firmware,
                        bodies: firmwares
                    });
                }, 500);
            }).catch(error => {
                console.error('GET Resolution ERROR:', error);
            });
        }
        // TODO: Should get list of rooms
        // Call api get list of room with filter total device < listDevices.length

        // Faked api to get list of valid room

    }
    const onSort = (sortable) => {
        setFirmware({
            ...firmware,
            sortable
        });
    }

    const onCheck = (value) => {
        const newFirmware = firmware.bodies.map(item => ({
            ...item,
            checked: item.id === value.id
        }));

        setFirmware({
            ...firmware,
            bodies: newFirmware
        });
    }

    // Sort list of rooms
    useEffect(() => {
        const { field, order } = firmware.sortable;
        const newLists = firmware.bodies.sort((a, b) => {
            const valueA = a[field].toString().toUpperCase();
            const valueB = b[field].toString().toUpperCase();

            if (valueA === valueB) return 0;
            if (order === 'ASC') {
                if (valueA > valueB) return 1;
                else if (valueA < valueB) return -1;
            } else {
                if (valueA > valueB) return -1;
                else if (valueA < valueB) return 1;
            }
        });
        setFirmware({
            ...firmware,
            bodies: newLists
        });
    }, [firmware.sortable]);

    useEffect(() => {
        const newFirmwares = listRooms.filter(item => {
            for (const key in item) {
                if (typeof item[key] === 'string') {
                    if (item[key].toUpperCase().includes(search.toUpperCase()))
                        return true;
                } else if (typeof item[key] === 'number') {
                    if (item[key] === parseInt(search)) return true;
                }
            }
        });
        setFirmware({
            ...firmware,
            bodies: newFirmwares
        });
    }, [search]);


    const arrayDevice = []
    for (let i = 0; i < listDevices.length; i++) {
        arrayDevice.push(listDevices[i].id)
    }

    let roomID = firmware.bodies.filter(item => item.checked === true)
    const UpdateFirmWare = () => {
        dataProvider('CREATE', "rebootDevices", {
            data: {
                key: 'updatefirmware',
                deviceId: arrayDevice,
                firmwareId: roomID[0].id
            }
        }).then(({ data }) => {
            console.log('send socket success:', data);
            onClose()
            getListDevices()
        }).catch(error => {
            console.error('send socket error:', error);
        })
    }

    useEffect(() => {
        setSearchText('')
        if (!open) {
            setFirmware({
                bodies: [],
                sortable: { field: 'name', order: 'DESC' },
            });
            setListRooms([]);
        }
    }, [open])

    return (
        <Dialog scroll='paper' onEnter={() => getListFirmWare(false)} open={open} maxWidth="md" fullWidth onClose={() => onClose()}>
            <DialogContent style={{ backgroundColor: '#f3f7fa' }}>
                <Box mx={4} mt={2}>
                    <Box display='flex' justifyContent='flex-end' alignItems='center'>
                        <Typography className={classes.btnClose}>{translate(`pos.user.close`)}</Typography>
                        <CloseButton onClick={() => onClose()} />
                    </Box>
                    <PageListLabel
                        label={translate('pos.devices.firmwareUpdate')}
                        searchPlaceholder={translate('pos.devices.search_firmware')}
                        onChangeText={setSearchText}
                        getList={() => getListFirmWare(true)}
                        buttonHidden
                        total={firmware.bodies.length}
                    />
                    <Table
                        config={config}
                        data={firmware}
                        loading={loading}
                        onCheck={onCheck}
                        onSort={onSort}
                        noDataLabel={translate('pos.devices.noFirmwareAvailable')}
                        color={''}
                    />
                </Box>
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
                <TextButton onClick={onClose} />

                <Box className={(firmware.bodies.length <= 0 || roomID.length <= 0) ? classes.disabled : classes.enabled}>

                    <Button variant='contained' color='primary' onClick={UpdateFirmWare}>
                        {translate('pos.common.update')}
                    </Button>
                </Box>

            </DialogActions>
        </Dialog>
    )
}

DialogListFirmWare.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    listDevices: PropTypes.array.isRequired
};
